import { useAtom, useAtomValue } from "jotai"
import { useEffect, useState } from "react"
import {
  AI_GENERATION_COMPLETION_STATUS,
  AI_GENERATION_PROGRESS
} from "../../constants"
import { teamAtom } from "../../stores/jotai/base"

import { importCanvasAtom } from "../../stores/jotai/generation-progress/import/importCanvasProcess"
import { exportInterviewAtom } from "../../stores/jotai/generation-progress/export/exportInterviewProcess"
import { toast } from "sonner"
import {renderErrorToast, toastStyle} from '../../../lib/ErrorToastMessage'
import {renderInProgressToast} from '../../../lib/ProgressInfoToastMessage'
const ProgressExportStatus = () => {
  const team = useAtomValue(teamAtom)
  const teamID = team?.groupID

  const [
    exportInterviewProgressSnackbarID,
    setExportInterviewProgressSnackbarID
  ] = useState(null)
  const [importCanvasProgressSnackbarID, setImportCanvasProgressSnackbarID] =
    useState(null)

  const [exportInterviewState, setExportInterviewState] =
    useAtom(exportInterviewAtom)
  const [importCanvasState, setImportCanvasState] = useAtom(importCanvasAtom)
  const exportInterviewInProgress =
    exportInterviewState[teamID]?.exportInterviewInProgress || null
  const exportInterviewInCompletionStatus =
    exportInterviewState[teamID]?.exportInterviewInCompletionStatus || null
  const importCanvasInProgress =
    importCanvasState[teamID]?.importCanvasInProgress || null
  const importCanvasInCompletionStatus =
    importCanvasState[teamID]?.importCanvasInCompletionStatus || null

  //export interview status
  useEffect(() => {
    if (exportInterviewInProgress === AI_GENERATION_PROGRESS.IN_PROGRESS) {
      const toastID = renderInProgressToast("Processing interview export. We'll notify you once it's done.")
      setExportInterviewProgressSnackbarID(toastID)
    }
  }, [exportInterviewInProgress])

  useEffect(() => {
    if (
      exportInterviewInCompletionStatus ===
      AI_GENERATION_COMPLETION_STATUS.FAILED
    ) {
      renderErrorToast(
        "Couldn't process interview export for you. Please reload and try again later.",
        () => {
          setExportInterviewState((prevState) => {
            const newState = { ...prevState }

            newState[teamID] = {
              exportInterviewInCompletionStatus:
                AI_GENERATION_COMPLETION_STATUS.NO_STATUS,
              exportInterviewInProgress: AI_GENERATION_PROGRESS.NOT_STARTED
            }

            return newState
          })
        }
      )
    } else if (
      exportInterviewInCompletionStatus ===
      AI_GENERATION_COMPLETION_STATUS.SUCCESSFULL
    ) {
      toast.success("Your export interview is ready to download!, Check Notification", {
        style: { ...toastStyle },
        onAutoClose: () => {
          setExportInterviewState((prevState) => {
            const newState = { ...prevState }

            newState[teamID] = {
              exportInterviewInCompletionStatus:
                AI_GENERATION_COMPLETION_STATUS.NO_STATUS,
              exportInterviewInProgress: AI_GENERATION_PROGRESS.NOT_STARTED
            }

            return newState
          })
        },
      });
    }

    if (
      exportInterviewInCompletionStatus !==
      AI_GENERATION_COMPLETION_STATUS.NO_STATUS
    ) {
      setTimeout(() => toast.dismiss(exportInterviewProgressSnackbarID), 500)
    }
  }, [exportInterviewInCompletionStatus])

  //import canvas status
  useEffect(() => {
    if (importCanvasInProgress === AI_GENERATION_PROGRESS.IN_PROGRESS) {
      const toastID = renderInProgressToast("Processing canvas import. We'll notify you once it's done.")
      setImportCanvasProgressSnackbarID(toastID)
    }
  }, [importCanvasInProgress])

  useEffect(() => {
    if (
      exportInterviewInCompletionStatus ===
      AI_GENERATION_COMPLETION_STATUS.FAILED
    ) {
      renderErrorToast(
        "Couldn't process canvas import for you. Please reload and try again later",
        () => {
          setImportCanvasState((prevState) => {
            const newState = { ...prevState }

            newState[teamID] = {
              importCanvasInCompletionStatus:
                AI_GENERATION_COMPLETION_STATUS.NO_STATUS,
              importCanvasInProgress: AI_GENERATION_PROGRESS.NOT_STARTED
            }

            return newState
          })
        }
      )    
    } else if (
      importCanvasInCompletionStatus ===
      AI_GENERATION_COMPLETION_STATUS.SUCCESSFULL
    ) {
      toast.success("Your canvas is ready", {
        onAutoClose: () => {
          setImportCanvasState((prevState) => {
            const newState = { ...prevState }

            newState[teamID] = {
              importCanvasInCompletionStatus:
                AI_GENERATION_COMPLETION_STATUS.NO_STATUS,
              importCanvasInProgress: AI_GENERATION_PROGRESS.NOT_STARTED
            }

            return newState
          })
        }
      })
    }

    if (
      importCanvasInCompletionStatus !==
      AI_GENERATION_COMPLETION_STATUS.NO_STATUS
    ) {
      setTimeout(() => toast.dismiss(importCanvasProgressSnackbarID), 500)
    }
  }, [importCanvasInCompletionStatus])

  useEffect(() => {
    setExportInterviewState((prevState) => {
      const newState = { ...prevState }

      delete newState[teamID]

      return newState
    })
    setImportCanvasState((prevState) => {
      const newState = { ...prevState }

      delete newState[teamID]

      return newState
    })
  }, [teamID])

  return <span />
}

export default ProgressExportStatus
